import { forwardRef, LegacyRef, MouseEvent } from 'react';
import { BasicButton } from '../buttons/BasicButton';

type CustomToggleProps = {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
};

export function FieldInputToggle(props: { label: string }) {
  const { label } = props;
  return (
    forwardRef(({ onClick }: CustomToggleProps,  _ref: LegacyRef<HTMLButtonElement>) => (
      <BasicButton
        onClick={(event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
        event.preventDefault();
        onClick(event);
        }}
        label={label}
      />
    ))
  );
}